import { api } from "../api";

/**
 * Клиент веб-версии для 3-шагового логина:
 *   1. sendEmailCode(email, purpose?) → на почту летит 6-значный код.
 *   2. verifyEmailCode(email, code) → возвращает ticket + mode.
 *   3-A. loginWithPin(ticket, pin, remember30d) — юзер уже был (mode=login).
 *   3-B. registerWithPin({ ticket, pin, ... }) — юзер новый (mode=register).
 */

export interface WebSessionUser {
  id: string;
  email: string | null;
  first_name: string | null;
  last_name: string | null;
  telegram_id: string | null;
  is_onboarded: boolean;
}

export interface WebSessionResponse {
  access_token: string;
  access_expires_at: string;
  refresh_expires_at: string;
  user: WebSessionUser;
}

export async function sendEmailCode(
  email: string,
  purpose: "login" | "register" | "auto" = "auto",
  turnstileToken?: string,
): Promise<{ mode: "login" | "register"; masked_email: string }> {
  const res = await api.post<{
    mode: "login" | "register";
    masked_email: string;
  }>("/auth/web/send-code", { email, purpose, turnstileToken });
  return res.data;
}

export async function verifyEmailCode(
  email: string,
  code: string,
): Promise<{ ticket: string; mode: "login" | "register" }> {
  const res = await api.post<{
    ticket: string;
    mode: "login" | "register";
  }>("/auth/web/verify-code", { email, code });
  return res.data;
}

export async function loginWithPin(
  ticket: string,
  pin: string,
  remember30d = true,
): Promise<WebSessionResponse> {
  const res = await api.post<WebSessionResponse>("/auth/web/pin-login", {
    ticket,
    pin,
    remember30d,
  });
  return res.data;
}

export async function registerWithPin(payload: {
  ticket: string;
  pin: string;
  pinConfirm: string;
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  remember30d?: boolean;
  referralCode?: string;
}): Promise<WebSessionResponse> {
  const res = await api.post<WebSessionResponse>("/auth/web/register", payload);
  return res.data;
}

export interface WebSessionRow {
  id: string;
  user_agent: string | null;
  ip: string | null;
  created_at: string;
  last_used_at: string;
  expires_at: string;
  is_current: boolean;
}

export async function listWebSessions(): Promise<WebSessionRow[]> {
  const res = await api.get<WebSessionRow[]>("/auth/web/sessions");
  return res.data;
}

export async function revokeWebSession(id: string): Promise<void> {
  await api.delete(`/auth/web/sessions/${id}`);
}
